import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const HeaderBarStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  transition: ${VARIABLES.TRANSITIONS.DEFAULT};
  display: flex;
  height: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT + 'px'};
  background-color: #ffffff;
  box-shadow: none;
  border-bottom: 1px solid #e7e9f3;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: ${VARIABLES.Z_INDEXS.LV_7};
  justify-content: space-between;

  &.is-offset {
    left: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH + 'px'};
    width: calc(100% - ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH + 'px'});
  }

  /* Child element styles
  ------------------------------- */

  .header-title {
    align-items: center;
    justify-content: flex-start;
    width: auto;
    margin-left: 35px;

    .app-logo {
      width: 145px;
      height: 46px;
      margin-right: 35px;
    }

    .app-title {
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XXL};
      margin-left: 35px;
      color: #1f2937;
      width: auto;
    }

    .logo-link {
      display: flex;

      .separate-line {
        margin-top: 10px;
        margin-right: 35px;
      }
    }

    .logo-sourcing {
      margin-right: 35px;
      width: 146px;
    }
  }

  .header-user {
    align-items: center;
    justify-content: flex-start;
    width: auto;
    margin-right: 53px;

    & > .notification {
      position: relative;
      margin-right: 3vw;

      .image-control {
        &.notification {
          width: 21px;
        }
      }

      .notification-amount {
        position: absolute;
        background-color: ${VARIABLES.COLORS.RED_1};
        border-radius: ${VARIABLES.BORDER_RADIUSES.SM};
        padding: 2px 6px;
        color: white;
        text-decoration: none;
        width: auto;
        font-family: ${VARIABLES.TYPOGRAPHYS.FONT_FAMILIES.SECOND};
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.SECOND_REGULAR};
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MN};
        top: -2px;
        left: 12px;
      }
    }

    .user {
      color: #1f2937;
      margin: 0;
      width: auto;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-end;
      max-width: none;
      white-space: nowrap;
      gap: 8px;

      .name,
      .role {
        width: auto;
        flex: 0 1 auto;
        align-items: center;
        overflow: hidden;
        white-space: nowrap;
      }

      .name .span,
      .role .span {
        display: inline;
        width: auto;
        max-width: 280px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .name {
        font-size: 14px;
        font-weight: 600;
      }

      .role {
        color: #64748b;
        font-size: 13px;

        &:before {
          content: '·';
          margin-right: 8px;
          color: #94a3b8;
        }
      }
    }

    .logout-icon {
      width: 18px;
      height: 18px;
      fill: none;
      stroke: #4b4acb;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }

  .separate-line {
    width: 2px;
    background-color: ${VARIABLES.COLORS.BLUE_1};
    height: 30px;
  }

  /* Modifiers
  ------------------------------- */

  /* Modifiers for single UI
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    height: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_XL + 'px'};

    .header-title {
      margin-left: 30px;

      .app-logo {
        width: 135px;
        margin-right: 30px;
      }

      .app-title {
        margin-left: 30px;
        font-size: 24px;
      }

      .logo-link {
        .separate-line {
          margin-right: 30px;
        }
      }

      .logo-sourcing {
        margin-right: 30px;
        width: 135px;
      }
    }

    .header-user {
      margin-right: 30px;

      .user {
        margin: 0 15px 0 30px;
        max-width: 430px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    height: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_LG + 'px'};

    .header-title {
      margin-left: 25px;

      .app-logo {
        width: 130px;
        margin-right: 25px;
      }

      .app-title {
        margin-left: 25px;
        font-size: 22px;
      }

      .logo-link {
        .separate-line {
          margin-right: 25px;
        }
      }

      .logo-sourcing {
        margin-right: 25px;
        width: 130px;
      }
    }

    .header-user {
      margin-right: 25px;

      .user {
        margin: 0 15px 0 25px;
        max-width: 410px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    height: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_MD + 'px'};

    .header-title {
      margin-left: 20px;

      .app-logo {
        width: 125px;
        margin-right: 20px;
      }

      .app-title {
        margin-left: 20px;
        font-size: 20px;
      }

      .logo-link {
        .separate-line {
          margin-right: 20px;
        }
      }

      .logo-sourcing {
        margin-right: 20px;
        width: 125px;
      }
    }

    .header-user {
      margin-right: 20px;

      .user {
        margin: 0 10px 0 20px;
        max-width: 400px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    height: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_SM + 'px'};

    .header-title {
      margin-left: 15px;

      .app-logo {
        width: 120px;
        margin-right: 15px;
      }

      .app-title {
        margin-left: 15px;
        font-size: 18px;
      }

      .logo-link {
        .separate-line {
          margin-right: 15px;
        }
      }

      .logo-sourcing {
        margin-right: 15px;
        width: 120px;
      }
    }

    .header-user {
      margin-right: 15px;

      .user {
        margin: 0 10px 0 15px;
        max-width: 390px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    height: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_XS + 'px'};

    &.is-offset {
      left: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_XS + 'px'};
      width: calc(100% - ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_XS + 'px'});
    }

    .header-title {
      margin-left: 10px;

      .app-logo {
        width: 100px;
        margin-right: 10px;
      }

      .app-title {
        margin-left: 10px;
        font-size: 16px;
      }

      .logo-link {
        .separate-line {
          margin-right: 10px;
        }
      }

      .logo-sourcing {
        margin-right: 10px;
        width: 100px;
      }
    }

    .header-user {
      margin-right: 10px;

      .user {
        margin: 0 10px 0 10px;
        max-width: 380px;
      }
    }
  }
`
